import { RouteRecordRaw } from 'vue-router';
import NoHeaderLayout from '@/components/layout/NoHeaderLayout.vue';
import AffiliateDashboardLayout from '@/components/tailwind/layout/affiliate/AffiliateDashboardLayout.vue';

const affiliateRoutes: Array<RouteRecordRaw> = [
  // This route is used to load and store on user's browser
  // the affiliate data then redirect to the signup page
  {
    path: '/affiliate/dashboard',
    name: 'AffiliateDashboardPage',
    meta: {
      label: 'AffiliateDashboardPage',
      layout: AffiliateDashboardLayout,
      accessWithSession: true,
      useTailwind: true,
    },
    component: () => import(/* webpackChunkName: "plugins" */ '@/views/tailwind/affiliate/AffiliateDashboardView.vue'),
  },
  {
    path: '/affiliate/r/:affiliateCode',
    name: 'AffiliateSignupPage',
    meta: {
      label: 'AffiliateSignupPage',
      layout: NoHeaderLayout,
      accessWithSession: undefined,
      useTailwind: true,
    },
    component: () => import(/* webpackChunkName: "plugins" */ '@/views/tailwind/affiliate/AffiliateSignupView.vue'),
  },
];

export default affiliateRoutes;
